import { APIService } from '../../../lib/api/APIService';

// Onboarding API — server-owned step catalogue, onboarding state (for
// resume), saving one answer at a time, and the optional redo and its
// invitation. All require auth: onboarding only happens post-signup.
class OnboardingAPI extends APIService {
  async getSteps() {
    return this.get('/api/onboarding/steps');
  }

  async getState() {
    return this.get('/api/onboarding/state');
  }

  async saveAnswer(stepId, value) {
    return this.post('/api/onboarding/answers', { step_id: stepId, value });
  }

  async ensureSession() {
    return this.post('/api/onboarding/session', {});
  }

  // Starts a redo of the user's current set, or returns the one already
  // open ({redo, started: false}). 409 onboarding_not_completed, 503
  // redo_unavailable (tables not migrated yet).
  async startRedo() {
    return this.post('/api/onboarding/redo', {});
  }

  // "Not now" on the invitation card, for the set it was shown for. 409
  // stale_set when the user's set has changed since.
  async dismissInvitation(setKey) {
    return this.post('/api/onboarding/invitation/dismiss', { set_key: setKey });
  }
}

// Create and export onboarding API instance
export const onboardingAPI = new OnboardingAPI();
